import ProjectExecutionPlanPage from "../../shared/project-execution-plan/ProjectExecutionPlanPage";

const SolarentOperatorProjectExecutionPlanPage = () => (
  <ProjectExecutionPlanPage source="SolarentOperator" />
);

export default SolarentOperatorProjectExecutionPlanPage;
